import { useStaticQuery, graphql } from "gatsby"

const useLayoutQuery = () => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      menusJson: dataJson(headerMenu: { elemMatch: { label: { ne: null } } }) {
        headerMenu {
          label
          uri
        }
      }
      allPosts: allMarkdownRemark(
        filter: { fields: { collection: { eq: "posts" } } }
        sort: { frontmatter: { date: DESC } }
      ) {
        nodes {
          id
          frontmatter {
            uri
            title
            date(formatString: "ddd DD MMMM")
            excerpt
          }
          html
        }
      }
    }
  `)

  // Map data to match the shape the header/footer components expect
  return {
    site: data.site,
    headerMenu: {
      menuItems: {
        nodes: data.menusJson?.headerMenu || [],
      },
    },
    allPosts: data.allPosts,
  }
}

export default useLayoutQuery
